<!-- BEGIN PRELOADER -->
<div *ngIf="loadingOverlay" (click)="loadingOverlay = false;" class="loader-overlay" style="opacity: 0.8;">
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<!-- END PRELOADER -->

<div class="header">
    <h2><strong>Relazione</strong> Finale</h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li class="active">Relazione Finale</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-content">
                <form #contractReportForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="row" style="margin-top: 80px; margin-bottom: 80px;">
                        <div class="col-md-8 col-md-offset-2">
                            <div class="form-group">
                                <label for="contract" class="col-sm-3 control-label">Convenzione *</label>
                                <div class="col-sm-9">
                                    <select class="form-control"
                                            name="contract"
                                            id="contract"
                                            style="width:100%;"
                                            required
                                            [(ngModel)]="contractSelected">
                                        <option [ngValue]="" disabled selected>Seleziona Convenzione...</option>
                                        <option *ngFor="let contract of contracts" [ngValue]="contract.id_contract">{{ contract.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="text-center m-t-20" style="margin-top: 100px !important;">
                                <button type="button"
                                        class="btn btn-embossed btn-success"
                                        (click)="openGenerateReport()"
                                        [disabled]="!contractReportForm.form.valid">
                                    <i class="fa fa-download"></i> Genera Relazione Finale</button>
                                <button type="button"
                                        class="btn btn-embossed btn-blue"
                                        (click)="openGenerateXLSReport()"
                                        [disabled]="!contractReportForm.form.valid">
                                    <i class="fa fa-download"></i> Genera Report Excel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
